const getTrainingType = (trainingType: string): string => {
  switch (trainingType) {
    case '1':
      return 'Train for days to months';
    case '2':
      return 'Train for up to 1 year';

    case '3':
      return 'Train for 1-2 years';
    case '4':
      return 'Train for 4 years';
    case '5':
      return 'Train for more than 4 years';
    default:
      return '';
  }
};

const getRequiredEducation = (jobZone: string): string => {
  switch (jobZone) {
    case '1':
      return 'Little or no preparation needed';
    case '2':
      return 'Some preparation needed';
    case '3':
      return 'Medium preparation needed';
    case '4':
      return 'Considerable preparation needed';
    case '5':
      return 'Extensive preparation needed';
    default:
      return '';
  }
};

export { getTrainingType, getRequiredEducation };
